import { useEffect, useState } from "react"
import FormViewActions from "./FormViewActions"
import { ID } from "../../../../@types/main"
import { FieldValues, UseFormReturn } from "react-hook-form"
import Form from "../Form"
import Modal from "@/components/base/Modal"
import { ButtonProps } from "@/components/ui/button"
import { ScrollArea } from "@/components/ui/scroll-area"

export interface FormViewProps<T extends FieldValues> {
  title?: string
  form?: UseFormReturn<any>
  type?: "modal" | "inline"
  onSubmit?: (values: T) => Promise<any>
  onSubmitted?: (item, values: T) => void
  // onCancel?: () => void
  onClose?: () => void
  onOpen?: () => void
  children?: React.ReactNode
  trigger?: React.ReactNode
  hideActions?: boolean
  size?: "xs" | "sm" | "md" | "lg" | "xl"
  ref?: React.Ref<any>
  confirmButtonProps?: Partial<ButtonProps>
  onExitTransitionEnd?: () => void
  initialValues?: T & { id?: ID }

  // Overwrite
  opened?: boolean
  open?: () => void
  destroyOnClose?: boolean
  // close?: () => void
  // className?: string
}

const FormViewCore = <T extends FieldValues>(props: FormViewProps<T>) => {
  const [submitting, setSubmitting] = useState(false)

  return (
    <Form
      form={props.form!}
      onSubmit={(model) => {
        setSubmitting(true)
        try {
          props
            .onSubmit?.(model)
            .then((res) => {
              props.onClose?.()
              return res
            })
            .catch(() => setSubmitting(false))
        } catch (error) {
          setSubmitting(false)
          throw error
        }
      }}
    >
      <ScrollArea className="w-full flex-1 pb-4" viewportClassName="px-6 py-1">
        {props.children}
      </ScrollArea>
      {!props.hideActions && (
        <FormViewActions submitting={submitting} onCancel={props.onClose!} confirmButtonProps={props.confirmButtonProps} className="px-6" />
      )}
    </Form>
  )
}

function FormView<T extends FieldValues>(props: FormViewProps<T>) {
  const [opened, setOpened] = useState(false)

  // const [_opened, { open: _open, close: _close, toggle: _toggle }] = useDisclosure(false)
  // const [exitTransitionEnded, setExitTransitionEnded] = useState(true)

  // const opened = props.opened !== undefined ? props.opened : _opened
  // const close = props.close !== undefined ? props.close : _close
  // const open = props.open !== undefined ? props.open : _open

  const handleClose = () => {
    setOpened(false)
    setTimeout(() => {
      props.onClose?.()
    }, 150)
  }

  // useEffect(() => {
  //   if (opened) {
  //     props.form?.reset()
  //   }
  // }, [opened])

  useEffect(() => {
    if (props.opened) {
      setOpened(true)
    }
  }, [props.opened])

  // useEffect(() => {
  //   if (props.initialValues) {
  //     props.form?.reset(props.initialValues as T)
  //   }
  // }, [props.form, props.initialValues])

  // const openModal = () => {
  //   open()
  // }

  // const onCancel = () => {
  //   if (submitting) return
  //   // close()
  //   props.onCancel?.()
  // }

  if (props.destroyOnClose && !props.opened && !props.trigger) {
    return null
  }

  if (props.type === "inline") {
    return <FormViewCore {...props} onClose={handleClose} />
  }

  return (
    <>
      {/* {props.trigger && (
        <div
          onClick={(e) => {
            props.onOpen?.()
            setOpened(true)
          }}
        >
          {props.trigger}
        </div>
      )} */}

      {/* {(opened || !exitTransitionEnded) && !!props.form && ( */}
      <Modal
        title={props.title}
        open={opened}
        // onOpenChange={_toggle}
        contentClassName="px-0"
        headerClassName="px-6"
        // onExitTransitionEnd={() => {
        //   setExitTransitionEnded(true)
        //   props.onExitTransitionEnd?.()
        // }}
        // centered
        size={props.size}
        onOpenChange={(open) => {
          if (!open) {
            handleClose()
          }
        }}
      >
        {(opened || props.opened) && <FormViewCore {...props} onClose={handleClose} />}
      </Modal>
      {/* )} */}
    </>
  )
}

export default FormView
